var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2565_5459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8848 101.07C40.1049 100.165 69.0748 79.1687 98.4428 101.07L103.523 94.2552C68.9957 68.4957 34.1448 94.0021 33.7962 94.2594L38.8848 101.07ZM38.3494 63.4926L46.198 55.6434L54.0463 63.4926L60.0561 57.4828L52.2075 49.6336L60.0561 41.7842L54.0463 35.7744L46.198 43.6235L38.3494 35.7744L32.3398 41.7842L40.1884 49.6336L32.3398 57.4828L38.3494 63.4926ZM81.9535 63.4926L89.8018 55.6434L97.6504 63.4926L103.66 57.4828L95.8113 49.6336L103.66 41.7842L97.6504 35.7744L89.8018 43.6235L81.9535 35.7744L75.9437 41.7842L83.7922 49.6336L75.9437 57.4828L81.9535 63.4926Z",
    fill: "#E9EBEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1749 136H116.825C127.396 136 136 127.396 136 116.825V19.1749C136 8.60158 127.396 0 116.825 0H19.1749C8.6038 0 0 8.60158 0 19.1749V116.825C0 127.396 8.6038 136 19.1749 136ZM8.5 19.1749C8.5 13.2897 13.2894 8.5 19.1749 8.5H116.825C122.711 8.5 127.5 13.2897 127.5 19.1749V116.825C127.5 122.711 122.711 127.5 116.825 127.5H19.1749C13.2897 127.5 8.5 122.711 8.5 116.825V19.1749Z",
    fill: "#E9EBEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2565_5459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 136,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.fc5bed6db6f9f5e420ecb1bad5ef9900.svg";
export { ForwardRef as ReactComponent };